import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './carousel-article-related-media-files-item.component.scss';
var CarouselArticleRelatedMediaFilesItem = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselArticleRelatedMediaFilesItem, _super);
    function CarouselArticleRelatedMediaFilesItem(element) {
        return _super.call(this, element) || this;
    }
    CarouselArticleRelatedMediaFilesItem.prototype.init = function () { };
    ;
    CarouselArticleRelatedMediaFilesItem.prototype.bindEvents = function () { };
    ;
    return CarouselArticleRelatedMediaFilesItem;
}(Base));
export { CarouselArticleRelatedMediaFilesItem };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-related-media-files-item/carousel-article-related-media-files-item.component.ts
// module id = 186
// module chunks = 0